import {Utils} from 'common/scripts/utils';

class FileInput {
    constructor(options) {
        this.options = options;
        this.elem = Utils.isElement(options.elem) ? options.elem : document.querySelector(options.elem);

        if (!this.elem) {
            console.error(`Element with selector "${options.elem}" not found!`);
        }

        this.input = this.elem.querySelector('.j-form__file-input');
        this.attachBlock = this.elem.querySelector('.j-form__file-label');
        this.infoBlock = this.elem.querySelector('.j-form__file-info');
        this.nameField = this.infoBlock.querySelector('.j-form__file-name');
        this.sizeField = this.infoBlock.querySelector('.j-form__file-size');
        this.deleteBtn = this.infoBlock.querySelector('.j-form__file-delete');
        this.required = this.elem;

        this.note = this.elem.querySelector('.j-form__file-accept');
        this.error = this.elem.querySelector('.j-form__file-error');
        this.inputType = this.input.dataset.type || 'all';

        // Допустимые типы файлов
        // eslint-disable-next-line
        this.grantedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpg', 'image/jpeg', 'image/png'];

        // Допустимый размер файлов в МБ
        this.maxSize = 15;
    }

    init() {
        if (!this.elem) {
            return;
        }

        this._bindEvents();
    }

    _bindEvents() {
        this.input.addEventListener('change', () => {
            const selectedFile = this.input.files;

            if (selectedFile.length && this._validation(selectedFile[0], this.inputType)) {
                this._setInfo(selectedFile);
                this.error.classList.add('is-hide');

                if (this.input.classList.contains('validate-input-error')) {
                    this.input.classList.remove('validate-input-error');
                }
            } else {
                this.error.classList.remove('is-hide');
            }

            this.note.classList.add('is-hide');
        });
    }

    /**
     * Валидация прикрепляемого файла
     * @param {File} file - прикреляемый файл
     * @param {string} type - тип допустимого прикрепляемого файла
     * @returns {boolean} результат валидации
     */
    _validation(file, type) {
        let valid = false;

        if (this._checkTypeFile(file.type, type)) {
            valid = this._checkFileSize(file.size);
        }

        return valid;
    }

    /**
     * Проверяем допустимость типа загружаемого файла
     * @param {string} fileType - Тип загружаемого файла
     * @param {string} typeAccess - допустимый тип загружаемого файла
     * @returns {boolean} - результат проверки
     */
    _checkTypeFile(fileType, typeAccess) {
        let isExist = [];
        let typesArray = [];

        typesArray = typeAccess === 'all' ? this.grantedTypes : this._getUniqueType(typeAccess);

        isExist = typesArray.filter((type) => {
            return type === fileType;
        });

        return isExist.length;
    }

    _getUniqueType(type) {
        switch (type) {
            case 'xls':
            case 'xlsx':
                // eslint-disable-next-line
                return ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            case 'doc':
                // eslint-disable-next-line
                return ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            case 'img':
                return ['image/jpg', 'image/jpeg', 'image/png'];
            case 'pdf':
                return ['application/pdf'];
            default:
                return [];
        }
    }

    /**
     * Проверяем размер загружаемого файла
     * @param {number} size - размер файла в байтах
     * @returns {boolean} - результат проверки
     */
    _checkFileSize(size) {
        return this.maxSize * 1024 * 1024 > Number(size);
    }


    /**
     * Устанавливаем информацию о загружаемом файле
     * @param {File} file - загружаемые файл
     */
    _setInfo(file) {
        const fileName = file[0]['name'];
        const fileSize = (parseInt(file[0]['size']) / 1024 / 1024).toFixed(2);

        // Прячем надпись с выбором файла
        if (this.attachBlock && !this.attachBlock.classList.contains('is-hide')) {
            this.attachBlock.classList.add('is-hide');
        }

        // ПОказываем данные загружаемого файла
        if (this.infoBlock && !this.infoBlock.classList.contains('is-active')) {
            this.nameField.innerText = fileName;
            this.sizeField.innerText = `${fileSize} Мб`;

            this.infoBlock.classList.add('is-active');
            this.elem.classList.add('is-active');
        }

        // Вешаем обработчик на кнопку очистки поля
        if (this.deleteBtn) {
            this.deleteBtn.addEventListener('click', () => {
                this._clearInput();
            });
        }
    }

    _clearInput() {
        // Очищаем данные файла и скрываем
        if (this.infoBlock && this.infoBlock.classList.contains('is-active')) {
            this.nameField.innerText = '';
            this.sizeField.innerText = '';
            this.input.value = '';

            this.infoBlock.classList.remove('is-active');
            this.elem.classList.remove('is-active');
        }

        // Отображаем выбор файла
        if (this.attachBlock && this.attachBlock.classList.contains('is-hide')) {
            this.attachBlock.classList.remove('is-hide');
            this.note.classList.remove('is-hide');
        }
    }
}

export default FileInput;
